import { ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export interface ExportOption {
  label: string;
  icon: React.ReactNode;
  action: () => void;
}

interface ExportDropdownProps {
  options: ExportOption[];
  buttonText?: string;
  buttonClassName?: string;
  dropdownWidth?: string;
  align?: "start" | "center" | "end";
  showIcon?: boolean;
}

export default function ExportDropdown({
  options,
  buttonText = "Export",
  buttonClassName = "flex w-[120px] sm:w-[148px] h-[48px] items-center justify-between gap-2 px-2 sm:px-[16px] py-[14px] border border-[#5C88C5] rounded-lg text-[14px] text-[#5C88C5] font-semibold focus:outline-none",
  dropdownWidth = "w-[148px]",
  align = "end",
  showIcon = true,
}: ExportDropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className={`${buttonClassName} group`}>
          {buttonText}
          {showIcon && (
            <ChevronDown className="w-[24px] h-[24px] transition-transform duration-200 group-data-[state=open]:rotate-180" />
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={`${dropdownWidth} bg-white`}
        align={align}
      >
        {options.map((option) => (
          <DropdownMenuItem
            key={option.label}
            onClick={option.action}
            className="flex items-center gap-2 text-[14px] font-semibold text-[#1E1E1E] cursor-pointer hover:bg-[#5C88C5] hover:text-white group"
          >
            {option.icon}
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
